import { render, staticRenderFns } from "./AssetListItem.vue?vue&type=template&id=2b9a21ca&scoped=true&functional=true"
import script from "./AssetListItem.vue?vue&type=script&lang=js"
export * from "./AssetListItem.vue?vue&type=script&lang=js"
import style0 from "./AssetListItem.vue?vue&type=style&index=0&id=2b9a21ca&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2b9a21ca",
  null
  
)

export default component.exports